<div class="modal-header">
  <h5 class="modal-title">Настройки двухфакторной аутентификации</h5>
  <button type="button" class="close" (click)="activeModal.dismiss()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">

  <!-- Загрузка статуса -->
  <ng-container *ngIf="isLoading && step === 'status'">
    <div class="d-flex justify-content-center py-2">
      <loader></loader>
    </div>
  </ng-container>

  <!-- Шаг: status -->
  <ng-container *ngIf="!isLoading && step === 'status' && status">
    <div class="mb-2">
      <span class="font-weight-bold">Статус:</span>
      <span class="badge badge-light-success ml-1" *ngIf="status.two_factor_enabled">Включена ({{methodLabel}})</span>
      <span class="badge badge-light-danger ml-1" *ngIf="!status.two_factor_enabled">Отключена</span>
    </div>

    <div class="mb-2">
      <p class="font-weight-bold mb-1">Требовать 2FA для:</p>
      <div *ngFor="let option of clientOptions" class="d-flex align-items-center mb-1">
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            [id]="'client-' + option.key"
            [checked]="option.enabled"
            [disabled]="option.mandatory"
            (change)="toggleClient(option)"
          />
          <label class="custom-control-label" [for]="'client-' + option.key">
            {{ option.label }}
            <span *ngIf="option.mandatory" class="badge badge-light-secondary ml-50">обязательно</span>
          </label>
        </div>
      </div>
    </div>

    <div class="dropdown-divider"></div>

    <div class="d-flex align-items-center mt-1">
      <button
        type="button"
        class="btn btn-outline-secondary mr-1"
        rippleEffect
        (click)="openRegenCode()"
      >
        <span [data-feather]="'refresh-cw'" class="mr-50"></span>
        Перевыпустить коды
      </button>
      <button
        type="button"
        class="btn btn-primary"
        rippleEffect
        [disabled]="!hasChanges"
        (click)="openClientsCode()"
      >
        Сохранить изменения
      </button>
    </div>
  </ng-container>

  <!-- Шаг: clients-code -->
  <ng-container *ngIf="step === 'clients-code'">
    <button type="button" class="btn btn-flat-secondary btn-sm mb-2 pl-0" rippleEffect (click)="goToStatus()">
      <span [data-feather]="'arrow-left'" class="mr-50"></span>Назад
    </button>
    <p class="mb-1 font-weight-bold">Подтвердите изменение клиентов 2FA</p>
    <ng-container *ngIf="status?.method === 'email'">
      <p class="mb-2 text-muted font-small-3" *ngIf="challengeSent">
        Код отправлен на {{ maskedEmail }}
      </p>
    </ng-container>
    <ng-container *ngIf="status?.method === 'totp'">
      <p class="mb-2 text-muted font-small-3">Введите код из приложения-аутентификатора.</p>
    </ng-container>
    <form [formGroup]="codeForm" (ngSubmit)="submitClientsCode()">
      <div class="form-group">
        <label class="form-label" for="clients-code">Код подтверждения:</label>
        <input
          type="text"
          id="clients-code"
          formControlName="code"
          class="form-control"
          placeholder="000000"
          maxlength="8"
          autocomplete="one-time-code"
          [class.is-invalid]="codeForm.get('code').errors && codeForm.get('code').touched"
        />
        <small *ngIf="codeForm.get('code').errors?.required && codeForm.get('code').touched"
               class="text-danger font-weight-bold">
          Поле обязательно
        </small>
        <small *ngIf="codeForm.get('code').errors?.minlength && codeForm.get('code').touched"
               class="text-danger font-weight-bold">
          Код не менее 6 символов
        </small>
      </div>
      <button
        type="submit"
        class="btn btn-primary d-flex justify-content-center"
        rippleEffect
        [disabled]="codeForm.invalid || isLoading"
      >
        <loader class="mr-1 btn-loader" *ngIf="isLoading"></loader>
        <span>Подтвердить</span>
      </button>
    </form>
  </ng-container>

  <!-- Шаг: regen-code -->
  <ng-container *ngIf="step === 'regen-code'">
    <button type="button" class="btn btn-flat-secondary btn-sm mb-2 pl-0" rippleEffect (click)="goToStatus()">
      <span [data-feather]="'arrow-left'" class="mr-50"></span>Назад
    </button>
    <p class="mb-1 font-weight-bold">Перевыпуск резервных кодов</p>
    <p class="mb-1 text-muted font-small-3">После подтверждения старые коды перестанут работать.</p>
    <ng-container *ngIf="status?.method === 'email'">
      <p class="mb-2 text-muted font-small-3" *ngIf="challengeSent">
        Код отправлен на {{ maskedEmail }}
      </p>
    </ng-container>
    <ng-container *ngIf="status?.method === 'totp'">
      <p class="mb-2 text-muted font-small-3">Введите код из приложения-аутентификатора.</p>
    </ng-container>
    <form [formGroup]="codeForm" (ngSubmit)="submitRegenCode()">
      <div class="form-group">
        <label class="form-label" for="regen-code">Код подтверждения:</label>
        <input
          type="text"
          id="regen-code"
          formControlName="code"
          class="form-control"
          placeholder="000000"
          maxlength="8"
          autocomplete="one-time-code"
          [class.is-invalid]="codeForm.get('code').errors && codeForm.get('code').touched"
        />
        <small *ngIf="codeForm.get('code').errors?.required && codeForm.get('code').touched"
               class="text-danger font-weight-bold">
          Поле обязательно
        </small>
        <small *ngIf="codeForm.get('code').errors?.minlength && codeForm.get('code').touched"
               class="text-danger font-weight-bold">
          Код не менее 6 символов
        </small>
      </div>
      <button
        type="submit"
        class="btn btn-primary d-flex justify-content-center"
        rippleEffect
        [disabled]="codeForm.invalid || isLoading"
      >
        <loader class="mr-1 btn-loader" *ngIf="isLoading"></loader>
        <span>Выпустить новые коды</span>
      </button>
    </form>
  </ng-container>

  <!-- Шаг: regen-backup -->
  <ng-container *ngIf="step === 'regen-backup'">
    <p class="mb-1 font-weight-bold">Новые резервные коды</p>
    <p class="mb-1 text-muted font-small-3">
      Сохраните коды в надёжном месте.
      <strong>Они показываются только один раз.</strong>
    </p>
    <div class="backup-codes-grid mb-2">
      <div *ngFor="let code of backupCodes">
        <code class="font-small-2">{{code}}</code>
      </div>
    </div>
    <button type="button"
            class="btn btn-outline-secondary mr-1"
            rippleEffect
            (click)="copyBackupCodes()">
      <span [data-feather]="'copy'" class="mr-50"></span>
      <span>{{copied ? 'Скопировано!' : 'Скопировать'}}</span>
    </button>
    <button type="button"
            class="btn btn-primary"
            rippleEffect
            (click)="activeModal.close()">
      Готово
    </button>
  </ng-container>

</div>
